module dg.loading {
    angular.module('dg.loading', [])
        .constant('waitInterval', 300)

        .config(($locationProvider, $httpProvider) => {
                //$httpProvider.interceptors.push('LoadingInterceptor');
            })
        .run(($rootScope, dataLoaderService: DataLoaderService, $transitions: any, $log) => {

            $transitions.onBefore({}, ($transition$) => {

                if ($transition$.ignored()) {
                    dataLoaderService.endLoading();
                }
                else {

                    let loadingLevel = $transition$.to().name.split(".").length - 1;
                    dataLoaderService.startLoading(loadingLevel);
                }
            });

            $transitions.onStart({}, ($transition$) => {
                //$log.warn("state url: " + "test url" + " start time:" + new Date().getHours() + ":" + new Date().getMinutes() + ":" +
                //    new Date().getSeconds() + ":" + new Date().getMilliseconds());
            });


            $transitions.onExit({}, ($transition$, $error$, $state) => {

            });

            $transitions.onRetain({}, ($transition$, $error$, $state) => {

            });

            $transitions.onEnter({}, ($transition$, $error$, $state) => {
                dataLoaderService.endLoading();
            });

            $transitions.onFinish({}, ($transition$, $error$, $state) => {

            });

            $transitions.onError({}, ($transition$, $error$, $state) => {
                dataLoaderService.endLoading();
            });

            $transitions.onSuccess({}, ($transition$, $state) => {
                dataLoaderService.endLoading();

                //$log.warn("state url: " + "test url" + " start time:" + new Date().getHours() + ":" + new Date().getMinutes() + ":" +
                //    new Date().getSeconds() + ":" + new Date().getMilliseconds());
            });
        });
    //.factory('LoadingInterceptor', ($rootScope, $q, dataLoaderService: dg.loading.DataLoaderService, SgDataSaverService, dgLoading) => {

    //    var pattern = dgLoading.getUrlPattern();
    //    var hasMatch = function (config) {
    //        return config.url.indexOf(pattern) > -1;
    //    }
    //    return {
    //        request: function (config) {
    //            if (hasMatch(config)) {
    //                dataLoaderService.requestStarted();
    //                SgDataSaverService.requestStarted();
    //            }
    //            return config;
    //        },
    //        response: function (success) {
    //            if (hasMatch(success.config)) {
    //                dataLoaderService.requestEnded();
    //                SgDataSaverService.requestCompleted();
    //            }
    //            return success;
    //        },
    //        responseError: function (rejection) {
    //            if (hasMatch(rejection.config)) {
    //                dataLoaderService.requestEnded();
    //                SgDataSaverService.requestFaild();
    //            }
    //            return $q.reject(rejection);
    //        }
    //    };
    //});
}

